import { motion } from "framer-motion";
import { SectionLabel } from "./SectionLabel";

const dimensions = [
  { key: "FOOD", desc: "What you eat, calories, macros and meals." },
  { key: "WEIGHT", desc: "Your weight and how it changes over time." },
  { key: "WORKOUTS", desc: "Your movement and exercise." },
  { key: "INSIGHTS", desc: "Patterns and observations across your behaviour." },
];

const fadeUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
  transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
};

export const FourDimensions = () => (
  <section className="py-24 md:py-32 lg:py-40 bg-white/50" data-testid="four-dimensions-section">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <SectionLabel number={2} title="Beyond Food" />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
        <div className="lg:col-span-5">
          <motion.h2
            {...fadeUp}
            className="font-heading text-3xl md:text-4xl lg:text-5xl leading-tight tracking-tight font-medium text-[#171717]"
          >
            Your health isn&rsquo;t one number.
          </motion.h2>
          <motion.p
            {...fadeUp}
            transition={{ ...fadeUp.transition, delay: 0.1 }}
            className="mt-6 text-lg md:text-xl leading-relaxed text-[#171717]/70 max-w-[440px]"
          >
            Quantify connects the things that affect your progress — instead
            of making you look at each one separately.
          </motion.p>
        </div>

        <div className="lg:col-span-7 lg:col-start-6">
          <div className="grid grid-cols-2 gap-4 md:gap-5">
            {dimensions.map((d, i) => (
              <motion.div
                key={d.key}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
                className="rounded-2xl border border-[#171717]/8 bg-[#F8F7F3] p-6 md:p-7"
                data-testid={`dimension-card-${d.key.toLowerCase()}`}
              >
                <p className="text-sm font-semibold tracking-[0.1em] uppercase text-[#176B4D]">
                  {d.key}
                </p>
                <p className="mt-3 text-base leading-relaxed text-[#171717]/65">{d.desc}</p>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="mt-6 flex flex-col items-center"
          >
            <span className="h-8 w-px bg-[#171717]/15" />
            <div className="rounded-full bg-[#171717] text-[#F8F7F3] px-6 py-2.5 text-sm font-medium tracking-wide">
              QUANTIFY
            </div>
            <span className="h-8 w-px bg-[#171717]/15" />
            <span className="text-sm font-semibold tracking-[0.15em] uppercase text-[#176B4D]">
              Understanding
            </span>
          </motion.div>
        </div>
      </div>
    </div>
  </section>
);
